<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal" tabindex="-1" id="issuerProfileModal" aria-labelledby="issuerProfileModalLabel" aria-hidden="false">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content shadow-none position-relative">
        <div class="modal-header">
          <h5 class="modal-title">Поиск пользователя (профиль эмитента)</h5>
          <div @click="closeModal" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body">
          <div class="d-flex mb-5">
            <button type="button" class="btn btn-sm me-2" :class="tab === 'search' ? 'btn-success' : 'btn-light'" @click="tab = 'search'">
              Поиск пользователя
            </button>
            <button type="button" class="btn btn-sm" :class="tab === 'withdraw' ? 'btn-success' : 'btn-light'" :disabled="!displayUserId" @click="tab = 'withdraw'">
              Списание с кошелька
            </button>
          </div>

          <div v-if="tab === 'search'">
            <div class="d-flex align-items-center gap-3 mb-4">
              <span class="text-gray-700 fw-semibold">Поиск по:</span>
              <div class="form-check form-switch m-0">
                <input
                  id="issuerProfile.searchType"
                  v-model="searchById"
                  class="form-check-input"
                  type="checkbox"
                />
              </div>
              <span class="text-gray-800">{{ searchById ? 'ID' : 'Номер' }}</span>
            </div>

            <input-field
              v-model="userName"
              id="issuerProfile.userName"
              name="issuerProfile.userName"
              :placeholder="searchById ? 'ID пользователя' : 'Номер телефона'"
              type="text"
              mb="5"
            />

            <div v-if="errorMessage" class="alert alert-danger d-flex align-items-center mb-0">
              <i class="ki-outline ki-information-5 fs-2hx text-danger me-3"></i>
              <div class="d-flex flex-column">
                <span>{{ errorMessage }}</span>
              </div>
            </div>

            <div v-else-if="profileData" class="border rounded p-4 bg-light">
              <div class="d-flex align-items-center flex-wrap gap-2">
                <span class="text-gray-700 fw-semibold me-2">User ID:</span>
                <span class="me-2">{{ displayUserId }}</span>
                <button type="button" class="btn btn-sm btn-info ms-auto" @click="copyUserId" :disabled="!displayUserId || copyDone">
                  <i class="ki-outline ki-copy fs-5 me-1"></i>
                  {{ copyDone ? 'Скопировано' : 'Копировать' }}
                </button>
              </div>
              <div v-if="displayUsername" class="d-flex align-items-center flex-wrap gap-2 mt-3">
                <span class="text-gray-700 fw-semibold me-2">Username:</span>
                <span>{{ displayUsername }}</span>
              </div>
            </div>
          </div>

          <div v-else>
            <div v-if="displayUsername" class="alert alert-success d-flex align-items-center mb-5">
              <i class="ki-outline ki-profile-circle fs-2hx me-3"></i>
              <span>Выбранный пользователь: {{ displayUsername }}</span>
            </div>

            <input-field
              :model-value="displayUserId"
              id="issuerProfile.withdraw.userId"
              name="issuerProfile.withdraw.userId"
              placeholder="ID пользователя"
              type="text"
              mb="5"
              required
              disabled
            />
            <div class="text-muted fs-8 mb-5 mt-n4">Заполняется автоматически после поиска пользователя</div>

            <div class="d-flex align-items-start gap-2">
              <div class="flex-grow-1">
                <input-field
                  v-model="withdrawAmount"
                  id="issuerProfile.withdraw.amount"
                  name="issuerProfile.withdraw.amount"
                  placeholder="Сумма списания"
                  type="number"
                  mb="5"
                  required
                />
              </div>
              <div class="form-control form-control-solid w-80px mb-5 text-center">UZS</div>
            </div>

            <input-field
              v-model="withdrawAssign"
              id="issuerProfile.withdraw.assign"
              name="issuerProfile.withdraw.assign"
              placeholder="Основание списания"
              type="text"
              mb="5"
              required
            />

            <div class="alert alert-warning d-flex align-items-center mb-0">
              <i class="ki-outline ki-information-5 fs-2hx text-warning me-3"></i>
              <span>После подтверждения сумма будет списана с кошелька. Банковский перевод выполняется отдельно.</span>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" @click="closeModal" class="btn btn-light btn-sm">Закрыть</button>
          <button v-if="tab === 'search'" type="button" class="btn btn-primary btn-sm" :disabled="!userNameTrimmed || loading" @click="fetchProfile">
            {{ loading ? 'Поиск...' : 'Найти' }}
          </button>
          <button v-else type="button" class="btn btn-success btn-sm" :disabled="!canWithdraw || withdrawing" @click="applyWithdraw">
            {{ withdrawing ? 'Списание...' : 'Списать средства' }}
          </button>
        </div>

        <div v-if="confirmOpen || successOpen" class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center dialog-overlay">
          <div class="bg-white rounded p-8 text-center shadow-sm" style="min-width: 320px;">
            <template v-if="confirmOpen">
              <div class="fs-5 fw-semibold mb-6">Вы уверены?</div>
              <div class="d-flex justify-content-center gap-3">
                <button type="button" class="btn btn-light" :disabled="withdrawSending" @click="cancelWithdraw">Нет</button>
                <button type="button" class="btn btn-success" :disabled="withdrawSending" @click="confirmWithdraw">
                  {{ withdrawSending ? 'Списание...' : 'Да' }}
                </button>
              </div>
            </template>
            <template v-else>
              <div class="fs-5 fw-semibold mb-6">Средства списаны успешно</div>
              <button type="button" class="btn btn-success" @click="closeModal">ОК</button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputField from '@/components/Fields/InputField'
import axios from 'axios'
import { notify } from '@kyvg/vue3-notification'

export default {
  name: 'IssuerProfileModal',
  components: { InputField },
  data() {
    return {
      tab: 'search',
      userName: '',
      searchById: false,
      profileData: null,
      errorMessage: '',
      loading: false,
      copyDone: false,
      withdrawAmount: '',
      withdrawAssign: '',
      withdrawing: false,
      confirmOpen: false,
      withdrawSending: false,
      successOpen: false,
    }
  },
  computed: {
    userNameTrimmed() {
      return this.userName != null ? String(this.userName).trim() : ''
    },
    displayUserId() {
      if (!this.profileData) return ''
      return this.profileData.profile?.userId ?? this.profileData.userId ?? ''
    },
    displayUsername() {
      if (!this.profileData) return ''
      return this.profileData.profile?.userName ?? this.profileData.profile?.username ?? this.profileData.userName ?? this.profileData.username ?? ''
    },
    canWithdraw() {
      const amount = Number(this.withdrawAmount)
      return Boolean(this.displayUserId && this.withdrawAssignTrimmed && !isNaN(amount) && amount > 0)
    },
    withdrawAssignTrimmed() {
      return this.withdrawAssign != null ? String(this.withdrawAssign).trim() : ''
    },
  },
  watch: {
    userName() {
      this.resetFoundUser()
    },
    searchById() {
      this.resetFoundUser()
    },
  },
  mounted() {
    setTimeout(() => {
      const el = document.getElementById('issuerProfileModal')
      if (el) {
        el.addEventListener('mousedown', (event) => {
          if (event.target.classList.contains('modal')) this.closeModal()
        })
      }
    }, 10)
  },
  methods: {
    resetFoundUser() {
      this.profileData = null
      this.errorMessage = ''
      this.copyDone = false
      this.tab = 'search'
      this.withdrawing = false
      this.confirmOpen = false
      this.withdrawSending = false
      this.successOpen = false
    },
    closeModal() {
      this.$emit('close', true)
      const modalEl = document.getElementById('issuerProfileModal')
      const instance = bootstrap.Modal.getInstance(modalEl)
      if (instance) instance.hide()
    },
    async copyUserId() {
      const id = this.displayUserId ? String(this.displayUserId) : ''
      if (!id) return
      try {
        await navigator.clipboard.writeText(id)
        this.copyDone = true
        setTimeout(() => { this.copyDone = false }, 2000)
      } catch (e) {
        console.error('Copy failed', e)
      }
    },
    async fetchProfile() {
      if (!this.userNameTrimmed) return
      this.loading = true
      this.errorMessage = ''
      this.profileData = null
      try {
        const { data } = await axios.get('/api/v1/profile/issuer', {
          params: this.searchById
            ? { user: this.userNameTrimmed }
            : { userName: this.userNameTrimmed },
          headers: {
            accept: 'application/json',
          },
        })
        if (data == null || (typeof data === 'object' && Object.keys(data).length === 0)) {
          this.errorMessage = 'Пользователь не найден'
        } else {
          this.profileData = data
        }
      } catch (err) {
        const status = err?.response?.status
        const message = err?.response?.data?.errorDescription || err?.response?.data?.message || err.message
        if (status === 404 || message?.toLowerCase?.().includes('not found') || message?.toLowerCase?.().includes('не найден')) {
          this.errorMessage = 'Пользователь не найден'
        } else {
          this.errorMessage = message || 'Пользователь не найден'
        }
      } finally {
        this.loading = false
      }
    },
    applyWithdraw() {
      if (!this.canWithdraw || this.withdrawing) return
      this.withdrawing = true
      this.confirmOpen = true
    },
    cancelWithdraw() {
      if (this.withdrawSending) return
      this.confirmOpen = false
      this.withdrawing = false
    },
    async confirmWithdraw() {
      if (this.withdrawSending) return
      this.withdrawSending = true
      try {
        await axios.post('/api/v1/billing/issuer/withdraw/apply', {
          userId: this.displayUserId,
          amount: {
            value: Number(this.withdrawAmount),
            currencyCode: 'UZS',
          },
          assign: this.withdrawAssignTrimmed,
        })
        this.confirmOpen = false
        this.successOpen = true
      } catch (err) {
        const message = err?.response?.data?.errorDescription || err?.response?.data?.message || err.message
        notify({ duration: 7000, type: 'error', speed: 1000, title: 'Ошибка', text: message || 'Не удалось списать средства' })
        this.confirmOpen = false
        this.withdrawing = false
      } finally {
        this.withdrawSending = false
      }
    },
  },
}
</script>

<style scoped>
.w-80px {
  width: 80px;
  height: calc(3.5rem + 2px);
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-overlay {
  z-index: 5;
  background: rgba(0, 0, 0, 0.35);
  border-radius: inherit;
}
</style>
